import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IconComponentProps } from '../IconTypes';
import { IconWrapper } from '../IconWrapper';

import { faThumbtack } from '@fortawesome/pro-solid-svg-icons';

export type ProSolidThumbtackProps = IconComponentProps;

export const ProSolidThumbtack = ({
  className,
  onClick,
  iconProps,
  type = 'button',
  ...props
}: ProSolidThumbtackProps) => {
  if (onClick) {
    return (
      <IconWrapper
        {...props}
        className={['font-awesome-button', className].join(' ')}
        type={type}
        onClick={onClick}
      >
        <FontAwesomeIcon
          {...iconProps}
          className="font-awesome-icon"
          icon={faThumbtack}
        />
      </IconWrapper>
    );
  }
  return (
    <FontAwesomeIcon
      {...iconProps}
      className={['font-awesome-icon', className].join(' ')}
      icon={faThumbtack}
    />
  );
};

ProSolidThumbtack.displayName = 'ProSolidThumbtack';
